import { render } from "./MrentedvehiclesIndex.vue?vue&type=template&id=19aefbc8&scoped=true"
import script from "./MrentedvehiclesIndex.vue?vue&type=script&lang=js"
export * from "./MrentedvehiclesIndex.vue?vue&type=script&lang=js"

import "./MrentedvehiclesIndex.vue?vue&type=style&index=0&id=19aefbc8&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19aefbc8"]])

export default __exports__